// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3mObx","logo":"Header_logo__2ins2","signupLogin":"Header_signupLogin__jGIOS","signup":"Header_signup__8rT-6","login":"Header_login__zfh4r"};